import axiosInstance, { createUrl } from ".";
import {
  IBodyTypeListDetails,
  IBodyTypeParams,
  IBodyTypeResponse,
} from "../interfaces/body-type.interface";

export interface ICreateBodyType {
  name: string;
  isActive: boolean;
  iconImageId?:any
}

export const createBodyType = async (
  data: ICreateBodyType
): Promise<IBodyTypeListDetails | {}> => {
  try {
    const result: any = await axiosInstance.post(
      createUrl("/api/v1/body-type"),
      data
    );
    if (result.status === 201) {
      return result;
    } else {
      return {};
    }
  } catch (err: any) {
    const errorMessage = { message: "" };
    if (
      err.response.data.statusCode !== 500 &&
      err.response.data.statusCode !== 404
    ) {
      errorMessage.message = err?.response?.data?.message[0];
    } else {
      errorMessage.message = "";
    }
    throw errorMessage;
  } finally {
  }
  // return {};
};

export const getBodyType = async (
  params?: IBodyTypeParams
): Promise<IBodyTypeResponse | []> => {
  try {
    const result: any = await axiosInstance.get(
      createUrl("/api/v1/body-type"),
      { params }
    );
    if (result.status === 200) return result?.data || [];
    return result;
  } catch (err: any) {
    console.log(">>>>>>>Error", err?.response?.data?.message[0]);
    throw err;
  } finally {
  }
};

export const getParticularBodyType = async (
  id: number
): Promise<IBodyTypeListDetails | {}> => {
  try {
    const result: any = await axiosInstance.get(
      createUrl("/api/v1/body-type/" + id)
    );
    if (result.status === 200) return result?.data?.data || {};
  } catch (err: any) {
    console.log(">>>>>>>Error", err?.response?.data?.message[0]);
  } finally {
  }
  return {};
};

export const updateParticularBodyType = async (
  id: number,
  data: ICreateBodyType
): Promise<IBodyTypeListDetails | {}> => {
  try {
    const result: any = await axiosInstance.patch(
      createUrl("/api/v1/body-type/" + id),
      data
    );
    if (result.status === 200) return result?.data?.data || {};
  } catch (err: any) {
    const errorMessage = { message: "" };
    if (
      err.response.data.statusCode !== 500 &&
      err.response.data.statusCode !== 404
    ) {
      errorMessage.message = err?.response?.data?.message;
    } else {
      errorMessage.message = "";
    }
    throw errorMessage;
  } finally {
  }
  return {};
};

export const publishParticularBodyType = async (
  id: number,
  data: { isActive: boolean }
): Promise<any> => {
  try {
    const result: any = await axiosInstance.post(
      createUrl("/api/v1/body-type/" + id + "/publish"),
      data
    );
    if (result.status === 200) return result?.data?.data || {};
  } catch (err: any) {
    const errorMessage = { message: "" };
    if (
      err.response.data.statusCode !== 500 &&
      err.response.data.statusCode !== 404
    ) {
      errorMessage.message = err?.response?.data?.message;
    } else {
      errorMessage.message = "";
    }
    throw errorMessage;
  } finally {
  }
  return {};
};
